module.exports = __webpack_public_path__ + "static/img/chuhuofail.e9a85c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/chuhuofail.png
// module id = rOiJ
// module chunks = 128